import {
  Component,
  OnDestroy,
  HostListener,
  signal,
  viewChild,
  viewChildren,
  inject,
  effect,
  computed,
  linkedSignal,
  ViewChildren,
  QueryList,
  ChangeDetectionStrategy,
  OnInit,
} from '@angular/core';

import { ClarityModule, ClrDatagridColumn } from '@clr/angular';
import { APIService } from 'src/app/services/APIService/api.service';
import { BasicStoreService } from 'src/app/services/BasicStore/basic-store.service';
import { first } from 'rxjs/operators';
import { SpinnerService } from 'src/app/services/Spinner/spinner.service';

import { AuthService } from 'src/app/services/Auth/auth.service';
import { TablePrettyPrintPipe } from 'src/app/pipes/tablePrettyPrint.pipe';
import { Row, Table } from 'src/app/models/ui/table';
import { MangelMediaApiFuncService } from 'src/app/services/MediaApiFunc/mangel-media-api-func.service';
import {
  TitleAndFileNames,
  MediaViewModalComponent,
} from '../_components/_shared/mediaviewmodal/mediaviewmodal.component';
import { ColumnFilterComponent } from '../_components/filter/column-filter/column-filter.component';
import { BackendLocaleDatePipe } from 'src/app/pipes/get-locale-date.pipe';
import { SonderinspektionmodalComponent } from '../_components/_modals/sonderinspektionmodal/sonderinspektionmodal.component';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { MrUnitTextPipe } from 'src/app/pipes/mrUnitText.pipe';
import { ProgressbarComponent } from '../_components/progressbar/progressbar.component';
import { MultiAuftragModalComponent } from './multi-auftrag-modal/multi-auftrag-modal.component';
import { FormsModule } from '@angular/forms';
import { DetailviewComponent } from '../_components/detailview/detailview.component';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { ColumnHideManService } from 'src/app/services/Shared/colhidemanager.service';
import { FILTER_TABLE_STORE, provideFilterStore } from 'src/app/shared/stores/filter-table.store';
import { GetByCallbackPipe } from 'src/app/pipes/get-by-callback.pipe';
import { ExcelService } from 'src/app/services/Shared/excel.service';
import { IconDgCellComponent } from '../_components/_shared/datagrid-cell/icon-dg-cell.component';
import { TableColumnConfigService } from 'src/app/services/Shared/table-column-config.service';
import { ColumnManagerPopupComponent } from '../_components/_shared/column-manager-popup/column-manager-popup.component';
import { HideableColumnStateService } from 'src/app/services/Shared/hideable-column-state.service';
import { DEFAULT_HIDDEN_COLUMNS } from 'src/app/pipes/hide-idcolumns.pipe';
import { getTokenRight } from 'src/app/misc/functions';
import { PrüfungsTypStore } from 'src/app/services/Shared/prüfung-typ.store';
import { MultirueckmeldungdialogComponent } from '../_components/_overlays/multirueckmeldungdialog/multirueckmeldungdialog.component';

const TABS_KEYS = ['Open', 'Auftrag', 'Done', 'All', 'Wartung', 'Stoerung'] as const;
type TabKeys = (typeof TABS_KEYS)[number];

@Component({
  selector: 'app-maengel',
  templateUrl: './maengel.component.html',
  styleUrls: ['./maengel.component.scss'],
  imports: [
    CommonModule,
    ClarityModule,
    FormsModule,
    DetailviewComponent,
    ProgressbarComponent,
    MediaViewModalComponent,
    MultiAuftragModalComponent,
    MultirueckmeldungdialogComponent,
    SonderinspektionmodalComponent,
    ColumnFilterComponent,
    IconDgCellComponent,
    ColumnManagerPopupComponent,
    MrUnitTextPipe,
    MrTranslatePipe,
    GetByCallbackPipe,
  ],
  providers: [
    provideFilterStore({ storage: 'mangel' }),
    TablePrettyPrintPipe,
    HideableColumnStateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaengelComponent implements OnDestroy, OnInit {
  private readonly mrTranslate = inject(MrTranslatePipe);
  private readonly excelService = inject(ExcelService);

  private readonly apiservice = inject(APIService);
  private readonly basicStore = inject(BasicStoreService);
  private readonly spinner = inject(SpinnerService);
  private readonly colHideService = inject(ColumnHideManService);
  private readonly tableColumnConfigService = inject(TableColumnConfigService);
  private readonly hideableColumnState = inject(HideableColumnStateService);
  protected readonly authService = inject(AuthService);
  protected readonly media = inject(MangelMediaApiFuncService);
  protected readonly pruefungsTyp = inject(PrüfungsTypStore);
  protected readonly filterStore = inject(FILTER_TABLE_STORE);

  private readonly modal = viewChild(SonderinspektionmodalComponent);
  private readonly columnFilters = viewChildren(ColumnFilterComponent);
  @ViewChildren(ClrDatagridColumn) columns: QueryList<ClrDatagridColumn>;

  protected readonly tables = signal<Record<TabKeys, Table>>({
    All: { columns: [], rows: [] },
    Auftrag: { columns: [], rows: [] },
    Done: { columns: [], rows: [] },
    Open: { columns: [], rows: [] },
    Stoerung: { columns: [], rows: [] },
    Wartung: { columns: [], rows: [] },
  });

  protected readonly activeTab = signal<TabKeys>(undefined);
  protected readonly table = computed(() => this.tables()[this.activeTab()]);

  protected readonly selectedTable = signal<Table<Row>>({ columns: [], rows: [] });
  protected readonly selected = linkedSignal<Row[]>(() => (this.activeTab(), []));
  protected readonly ostammid = linkedSignal<number>(() => (this.activeTab(), undefined));
  protected readonly rechte = linkedSignal<number>(() => (this.activeTab(), 1));

  private readonly reloadTabsIsReady = new Subject();

  protected readonly showdetailview = signal(false);
  protected readonly hidedetailview = signal(false);
  protected readonly showbemerkung = signal(false);
  protected readonly showprogressbar = signal(false);
  protected readonly split50 = signal(false);
  protected readonly sidenavenlarged = signal(false);
  protected readonly progressbarenlarged = signal(false);
  protected readonly progressbars = signal<any>(undefined);
  protected readonly indexScrub = signal(-1);

  protected readonly mangelbemerkung = signal('');
  curID: number = 0;
  curostammid: number = 0;

  protected readonly formatDBName = localStorage.getItem('FormatCurDB').replace('_', ' ');

  protected readonly isMultiRueckModalOpen = signal(false);
  protected readonly isMultiAuftragModalOpen = signal(false);

  protected readonly allInspections = signal(false);
  protected readonly loading = signal(true);

  protected readonly mangelMedia = signal<TitleAndFileNames[]>(undefined);
  protected readonly hides = signal(MaengelComponent.defaultHides());
  private readonly colFname = 'Maengel';
  private readonly columnConfigStorageKey = 'Maengel';

  protected readonly allowAuftr = getTokenRight(
    JSON.parse(this.authService.decrypt(localStorage.getItem('rights'))).program,
    'AllowPAuftrCreate'
  );

  constructor() {
    effect(() => this.showdetailview.set(this.ostammid() != null));
    this.filterStore.registerFilters(this.columnFilters);
    this.filterStore.registerTable(this.table);
  }

  reloadMangel(reloadTabsWaitReady: Subject<any> | boolean = undefined, _event?: any) {
    this.loading.set(true);
    this.spinner.enable();
    if (reloadTabsWaitReady && reloadTabsWaitReady instanceof Subject) {
      reloadTabsWaitReady.pipe(first((isReady: any) => isReady?.refreshMaengel)).subscribe(() => {
        this.getMaengelStore();
      });
    } else {
      this.apiservice.getMaengel(this.allInspections(), this.pruefungsTyp.KPRUVID()).subscribe(maengel => {
        let store = this.basicStore.getComponentStore('maengel');
        this.basicStore.setComponentStore('maengel', {
          ...store,
          maengel,
          ostammid: this.ostammid() ?? store.ostammid,
          allInspections: this.allInspections(),
          activeTab: this.activeTab(),
        });
        setTimeout(() => this.getMaengelStore(), 10);
      });
    }
  }
  downloadFile(data: any, charset: string, name: string, extension: string, cb: any) {
    let blob = new Blob(['\ufeff' + data], { type: charset });
    let dwldLink = document.createElement('a');
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {
      //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute('target', '_blank');
    }
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', name + '.' + extension);
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
    cb();
  }

  exportCSV() {
    this.excelService.exportAsExcelFile(this.filterStore.filteredRows(), this.mrTranslate.transform('Mängel'), true, [
      'omazsid',
    ]);
  }

  ngOnInit(): void {
    this.spinner.enable();
    this.getMaengelStore();

    this.hides.set(this.colHideService.initColHide(MaengelComponent.defaultHides(), this.colFname));
  }

  protected hideableState(columnId: string) {
    return this.hideableColumnState.stateFor(columnId, this.hides());
  }

  private columnHiddenChangeHandle: ReturnType<typeof setTimeout> | null = null;
  columnHiddenChange() {
    // Clarity emits (clrDgHiddenChange) once per column, so a reorder or a bulk
    // toggle fires this handler for every column at once. Coalesce the burst into
    // a single service call and skip the update when the hidden set is unchanged,
    // otherwise every hideIDColumns binding is invalidated a second time for free.
    if (this.columnHiddenChangeHandle) clearTimeout(this.columnHiddenChangeHandle);
    this.columnHiddenChangeHandle = setTimeout(() => {
      this.columnHiddenChangeHandle = null;
      this.colHideService.columnHiddenChange(this.columns).then((x: string[]) => {
        const merged = this.mergeHiddenForActiveTab(x);
        if (this.sameHiddenSet(merged, this.hides())) return;

        this.hides.set(merged);
        this.saveColumnConfig();
      });
    }, 60);
  }

  private sameHiddenSet(a: readonly string[], b: readonly string[]): boolean {
    if (a.length !== b.length) return false;
    const setB = new Set(b.map(id => id.toLowerCase()));
    return a.every(id => setB.has(id.toLowerCase()));
  }

  removeColFilter() {
    this.colHideService.removeColHide(this.colFname);
    this.hides.set(MaengelComponent.defaultHides());
    this.saveColumnConfig();
  }

  /**
   * Voreinstellung, solange der Benutzer in "Spalten verwalten" nichts gespeichert hat. Eine
   * gespeicherte Auswahl gewinnt immer, sonst liessen sich ID-Spalten wie `ostammid` (zum
   * Debuggen gebraucht) gar nicht einblenden.
   */
  private static defaultHides(): string[] {
    return ['mangelfoto', 'rueckbilder', ...DEFAULT_HIDDEN_COLUMNS];
  }

  getMaengelStore() {
    this.basicStore
      .getComponentStoreAsync('maengel', true)
      .pipe(first(val => !!val.maengel))
      .subscribe(cmpStore => {
        this.activeTab.update(tab => tab ?? cmpStore['activeTab'] ?? 'Open');
        this.showdetailview.update(val => val || (cmpStore['showdetailview'] ?? false));
        this.hidedetailview.update(val => val || (cmpStore['hidedetailview'] ?? false));
        this.split50.update(val => val || (cmpStore.split50 ?? false));
        this.sidenavenlarged.update(val => val || (cmpStore.sidenavenlarged ?? false));

        if (this.showdetailview()) {
          this.ostammid.update(ostammid => ostammid ?? cmpStore['ostammid']);
        }

        if (cmpStore['maengel']) {
          this.loading.set(true);

          this.tables.update(tables => {
            const { columns, rows: all } = cmpStore['maengel'].all as Table;
            tables.All = { columns, rows: all };
            tables.Open = {
              columns,
              rows: all.filter(row => !row.erledigt),
            };
            tables.Done = {
              columns,
              rows: all.filter(row => !!row.erledigt),
            };
            tables.Auftrag = {
              columns,
              rows: tables.Open.rows.filter(row => !!row.auftrag),
            };
            // Offline-/PWA-Modus liefert wartung/stoerung als null (siehe mangelDB.GetMaengel)
            tables.Wartung = cmpStore['maengel'].wartung ?? { columns: [], rows: [] };
            tables.Stoerung = cmpStore['maengel'].stoerung ?? { columns: [], rows: [] };

            return { ...tables };
          });

          this.applyStoredColumnConfig();

          this.allInspections.set(cmpStore['allInspections'] ?? false);

          this.loading.set(false);
          this.spinner.disable();
        }
      });
  }

  @HostListener('window:beforeunload')
  ngOnDestroy() {
    this.basicStore.setComponentStore('maengel', {
      maengel: {
        all: this.tables().All,
        wartung: this.tables().Wartung,
        stoerung: this.tables().Stoerung,
      },
      allInspections: this.allInspections(),
      activeTab: this.activeTab(),
      ostammid: this.ostammid(),
      showdetailview: this.showdetailview(),
      hidedetailview: this.hidedetailview(),
      split50: this.split50(),
      sidenavenlarged: this.sidenavenlarged(),
    });

    this.colHideService.setColHide(this.columns, this.colFname);
  }

  openObject(ost: number, rechte: number) {
    this.ostammid.set(ost);
    this.rechte.set(rechte);
  }
  openBemerkung(bemerkung: string, id: number) {
    this.mangelbemerkung.set(bemerkung);
    this.curID = id;
    this.showbemerkung.set(true);
  }

  openSonderinspektion(row: any) {
    this.curID = row.omazsid;
    this.curostammid = row.ostammid;

    let inData = {
      Status: 1,
      OSTAMMID: row.ostammid,
      OMAZSID: row.omazsid,
      OTYPID: row.h1,
      OSISPKID: 0,
      Mangel: row.mangel,
      aktive: true,
      beginn: BackendLocaleDatePipe.now,
      intervall: 10,
    };
    this.modal().open(inData);

    this.modal().onOK.subscribe(res => {
      if (res == true) {
        this.modal().close();
        this.basicStore.reloadTabs({ emitter: this.reloadTabsIsReady });
      }
    });
  }

  saveMangelBemerkung() {
    this.showbemerkung.set(false);
    var req = {
      bemerkung: this.mangelbemerkung(),
    };
    this.apiservice
      .saveMangelBemerkung(req, this.curID)
      .pipe(first())
      .subscribe(() => {
        setTimeout(() => {
          this.reloadMangel();
          // this.tabChange();
        });
      });
    this.curID = 0;
    this.mangelbemerkung.set('');
  }

  enlargeSidenav(event) {
    if (event.mode == 'full') {
      this.sidenavenlarged.set(event.val);
    } else if (event.mode == 'half') {
      this.split50.set(event.val);
    } else if (event.mode == 'progress') {
      this.showprogressbar.set(event.val);
      this.progressbars.set({});
    } else if (event.mode == 'hidden') {
      this.hidedetailview.set(event.val);
    } else if (event.mode == 'close') {
      this.showdetailview.set(false);
      this.showprogressbar.set(false);
    }
  }

  protected closeMultiRueckModal(toReload: boolean) {
    setTimeout(() => this.isMultiRueckModalOpen.set(false));
    if (toReload) this.callReload();
  }

  protected closeMultiAuftragModal(toReload: boolean) {
    setTimeout(() => this.isMultiAuftragModalOpen.set(false));
    if (toReload) this.callReload();
  }

  private callReload() {
    this.selected.set([]);
    this.basicStore.reloadTabs({
      emitter: this.reloadTabsIsReady,
      reloadAnlagen: false,
    });
    this.reloadMangel(this.reloadTabsIsReady);
  }
  public UpdateSelected(event) {
    this.selected.set(event);
    if(!this.selectedTable().columns.length) this.selectedTable().columns = this.table().columns;
    this.selectedTable().rows = this.selected();
  }


  handleScrub(index: number) {
    this.indexScrub.set(index);
  }

  showProgressData(data) {
    if (data) {
      this.progressbars.set(data);
      this.showprogressbar.set(true);
    }
  }

  enlargeProgressbar(val?: boolean) {
    this.progressbarenlarged.update(old => val || !old);
  }

  protected readonly getColumnWidth = (columnId: string): number => {
    const widthMapping: { [key: string]: number } = {
      status: 100,
      instandsetzung: 350,
      auftragnehmer: 350,
      erledigt_durch: 350,
      mangelfoto: 350,
      stellwerk: 250,
      Ort: 250,
      mangel: 250,
      bemerkung: 250,
      lage: 250,
      Bezirk: 170,
      messreg_bezirk: 170,
    };

    return widthMapping[columnId] || columnId.length * 7.5 + 45;
  };

  protected readonly normalizedId = (id: string): string => {
    return id.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-_]/g, '');
  };

  protected onColumnOrderChange(order: readonly string[]) {
    const normalizedOrder = order.map(id => id.toLowerCase());
    const orderIndex = new Map(normalizedOrder.map((id, index) => [id, index]));

    // Only rebuild the column arrays when the emitted order actually changed.
    const activeColumns = this.table()?.columns ?? [];
    const orderChanged = [...activeColumns]
      .sort((a, b) => {
        const aIndex = orderIndex.get(a.id.toLowerCase()) ?? Number.MAX_SAFE_INTEGER;
        const bIndex = orderIndex.get(b.id.toLowerCase()) ?? Number.MAX_SAFE_INTEGER;
        return aIndex - bIndex;
      })
      .some((column, index) => column.id !== activeColumns[index].id);

    if (orderChanged) {
      this.tables.update(tables => {
        const updated = { ...tables };
        for (const key of TABS_KEYS) {
          updated[key] = {
            ...updated[key],
            columns: [...(updated[key]?.columns ?? [])].sort((a, b) => {
              const aIndex = orderIndex.get(a.id.toLowerCase()) ?? Number.MAX_SAFE_INTEGER;
              const bIndex = orderIndex.get(b.id.toLowerCase()) ?? Number.MAX_SAFE_INTEGER;
              return aIndex - bIndex;
            }),
          };
        }

        return updated;
      });
    }

    this.saveColumnConfig();
  }

  private applyStoredColumnConfig() {
    const allColumns = this.getAllColumns();
    if (!allColumns.length) return;

    const applied = this.tableColumnConfigService.applyConfig(
      this.columnConfigStorageKey,
      allColumns,
      this.hides()
    );

    // Sort each tab by the shared saved order instead of overwriting every tab
    // with the active tab's columns: Wartung/Stoerung can carry tab-specific
    // columns that must not be replaced. Unknown ids keep their original order
    // at the end.
    const orderIndex = new Map(applied.order.map((id, index) => [id, index]));
    const sortByOrder = (cols: Table['columns']) =>
      [...cols].sort((a, b) => {
        const aIndex = orderIndex.get(a.id.toLowerCase()) ?? Number.MAX_SAFE_INTEGER;
        const bIndex = orderIndex.get(b.id.toLowerCase()) ?? Number.MAX_SAFE_INTEGER;
        return aIndex - bIndex;
      });

    this.hides.set([...applied.hidden]);
    this.tables.update(tables => {
      const updated = { ...tables };
      for (const key of TABS_KEYS) {
        updated[key] = {
          ...updated[key],
          columns: sortByOrder(updated[key]?.columns ?? []),
        };
      }

      return updated;
    });
  }

  private saveColumnConfig() {
    this.tableColumnConfigService.saveConfig(this.columnConfigStorageKey, {
      order: this.getAllColumns().map(column => column.id),
      hidden: this.hides(),
    });
  }

  private mergeHiddenForActiveTab(activeTabHidden: readonly string[]): string[] {
    const activeColumnIds = new Set((this.table()?.columns ?? []).map(column => column.id.toLowerCase()));
    const hidden = new Set(
      this.hides()
        .map(id => id.toLowerCase())
        .filter(id => !activeColumnIds.has(id))
    );

    activeTabHidden.forEach(id => hidden.add(id.toLowerCase()));
    return [...hidden];
  }

  private getAllColumns(): Table['columns'] {
    const seen = new Set<string>();

    return TABS_KEYS.flatMap(key => this.tables()[key]?.columns ?? []).filter(column => {
      const id = column.id.toLowerCase();
      if (seen.has(id)) return false;

      seen.add(id);
      return true;
    });
  }
}
